class EventBus {
  events = {}

  add (event, cb) {
    if (!event || !cb) return

    if (!this.events[event]) this.events[event] = []

    this.events[event].push(cb)
  }

  remove (event, cb) {
    if (!event) this.events = {}

    else if (event && !cb) this.events[event] = []

    else {
      const e = this.events[event]

      if (e && e.length) {
        for (let i = 0; i < e.length; i++) {
          if (e[i] === cb) {
            e.splice(i, 1)
            break
          }
        }
      }
    }
  }

  emit (event, args) {
    if (event && this.events[event]) {
      const e = this.events[event]

      e.forEach(fn => {
        try {
          fn(JSON.parse(args))
        } catch (e) {
          fn(args)
        }
      })
    }
  }
}

export default EventBus
